"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridItem = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const css_1 = __importDefault(require("@styled-system/css"));
const tools_1 = require("../../tools");
const transformPropVal_1 = require("../../tools/transformPropVal");
const Box_1 = require("../Box");
function GridItem(props) {
    return jsx_runtime_1.jsx(StyledBox, Object.assign({}, props), void 0);
}
exports.GridItem = GridItem;
const StyledBox = tools_1.styled(Box_1.Box)(props => css_1.default({
    gridColumn: transformSpanProp(props.colSpan),
    gridRow: transformSpanProp(props.rowSpan),
    gridColumnStart: props.colStart,
    gridColumnEnd: props.colEnd,
    gridRowStart: props.rowStart,
    gridRowEnd: props.rowEnd,
}));
function transformSpanProp(val) {
    return transformPropVal_1.transformPropVal(val, value => (value === 'auto' ? 'auto' : `span ${value}/span ${value}`));
}
//# sourceMappingURL=index.js.map